import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import useStyles from './styles';
import usePaymentForm from './usePaymentForm';
import { useIsDesktop, useTranslations } from 'components/utilities';
import ControlErrors from 'components/elements/atoms/ControlErrors';
import LoadingOverlay from 'components/elements/molecules/LoadingOverlay';

const PaymentFormContent = ({ booking }) => {
	const classes = useStyles();

	const { t } = useTranslations();

	const {
		handleSubmit,
		paymentCallbackUrl,
		error,
		errors,
		isCardValid,
		isLoading,
		isFormVisible,
	} = usePaymentForm();

	const isDesktop = useIsDesktop();

	return (
		<>
			{isLoading && <LoadingOverlay />}
			{error && (
				<Box mb={2}>
					<Alert severity="error">{error}</Alert>
				</Box>
			)}
			{paymentCallbackUrl && (
				<iframe
					title="3DS"
					src={paymentCallbackUrl}
					className={classes.paymentCallbackFrame}
				></iframe>
			)}
			{isFormVisible && (
				<form
					id="payment-form"
					className="payment-form"
					method="POST"
					action="https://merchant.com/charge-card"
					onSubmit={handleSubmit}
				>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<label className={classes.label}>
								{t('payment.form.card_number_label')}
							</label>

							<div className={`card-number-frame ${classes.inputFrame}`} />
							<ControlErrors errors={errors.cardNumber} />
						</Grid>
						<Grid item xs={12}>
							<Grid container spacing={1}>
								<Grid item xs={4}>
									<label className={classes.label}>
										{t('payment.form.expiry_date_label')}
									</label>

									<div className={`expiry-date-frame ${classes.inputFrame}`} />
									<ControlErrors errors={errors.expiryDate} />
								</Grid>
								<Grid item xs={8}>
									<label className={classes.label}>
										{t('payment.form.cvv_label')}
									</label>

									<div className={`cvv-frame ${classes.inputFrame}`} />
									<ControlErrors errors={errors.cvv} />
								</Grid>
							</Grid>
						</Grid>
					</Grid>

					<Box display="flex" justifyContent="center" mt={isDesktop ? 12 : 4}>
						<Button
							type="submit"
							id="pay-button"
							variant="contained"
							color="primary"
							size="large"
							disabled={!isCardValid || isLoading}
							fullWidth
						>
							{t('payment.form.btn_submit')} {booking.gross_amount} SAR
						</Button>
					</Box>
				</form>
			)}
		</>
	);
};

PaymentFormContent.propTypes = {
	booking: PropTypes.object,
};

export default PaymentFormContent;
